import { forwardRef } from "react";
import React from "react";
function SvgAiSpark({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="var(--angelou-svg-primary-color, #fff)"
        d="M12 9c.061 0 .115.04.131.1.515 1.865.904 2.254 2.769 2.769a.136.136 0 0 1 0 .262c-1.865.515-2.254.904-2.769 2.769a.136.136 0 0 1-.262 0c-.515-1.865-.904-2.254-2.769-2.769a.136.136 0 0 1 0-.262c1.865-.515 2.254-.904 2.769-2.769.016-.06.07-.1.131-.1ZM6.5 1a.25.25 0 0 1 .241.184c.945 3.419 1.656 4.13 5.076 5.075a.25.25 0 0 1 0 .482c-3.42.945-4.131 1.656-5.076 5.075a.25.25 0 0 1-.482 0c-.945-3.419-1.656-4.13-5.076-5.075a.25.25 0 0 1 0-.482c3.42-.945 4.131-1.656 5.076-5.075A.25.25 0 0 1 6.5 1Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgAiSpark);
export default ForwardRef;
